import { useAuth } from "#root/components/auth";
import { AutoCompleteField, BooleanSelectField, CategoryNameField, CompanyNameField, CurrencyField, DateField, DeleteField, DomainField, EmailField, FieldSet, FullNameField, GenericNameField, HiddenField, InputField, IntegerField, JSONEditorField, Markdown, NumberField, ObjectCodeField, OptionField, PasswordConfirmField, PasswordField, PhoneField, ProductNameField, SelectField, StringField, SubmitField, TagsField, TextAreaField, TimeIntervalField, TimeOfDayField, TimestampField, TimezoneField, TaxIDField, UUIDField, ValidityIndicator, WebsiteURIField } from "#root/components/form/fields";
import cookies from "browser-cookies";
import type { ReactNode } from "react";
import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { collection } from "../schema/signup";
import StandardEditor from "./standard-editor";

export default function CreateAccount({ initialData }: { initialData?: Record<string, unknown> }): ReactNode {
  const auth = useAuth();
  const navigate = useNavigate();

  const formProps = useMemo(
    () => ({
      id: "new",
      initialData,
      affiliate: cookies.get("affiliate"),
      collection,
    }),
    [initialData],
  );

  const handleSave = useCallback(
    ({ authToken }: { authToken?: string }) => {
      //TODO: authToken should be passed in via the row, right now it is returned in a non-conforming way
      auth.setLoginCredentials(authToken!);
      navigate("/account/profile");
    },
    [navigate, auth],
  );

  return (
    <StandardEditor {...formProps} buttonOptions={{ save: { position: "bottom", label: "Create Account" } }} onSave={handleSave}>
      <FieldSet name="affiliate" className="hidden">
        <HiddenField/>
      </FieldSet>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6">
        <FieldSet name="type" className="sm:col-span-2">
          <label>I am looking for data for:</label>
          <SelectField required>
            <OptionField value="corporation">Commercial Use</OptionField>
            <OptionField value="individual">Individual Use</OptionField>
          </SelectField>
          <ValidityIndicator/>
        </FieldSet>
        <FieldSet name="name">
          <label>Your Full Name</label>
          <FullNameField required autoComplete="name"/>
          <ValidityIndicator/>
        </FieldSet>
        <FieldSet name="company">
          <label>Company Name</label>
          <CompanyNameField autoComplete="organization"/>
          <ValidityIndicator/>
        </FieldSet>
        <FieldSet name="email">
          <label>Your Email Address</label>
          <EmailField required autoComplete="email"/>
          <ValidityIndicator/>
        </FieldSet>
        <FieldSet name="password">
          <label>Password</label>
          <PasswordField required autoComplete="new-password"/>
          <ValidityIndicator/>
        </FieldSet>
      </div>
    </StandardEditor>
  );
}
